const ProductItems = [
  {
    id: 13,
    title: "E-Commerce",
    path: "/ecommerce-website-development",
    cName: "drop_down_cont1",
  },
  {
    id: 27,
    title: "CRM",
    path: "/crm-software",
    cName: "drop_down_cont2",
    idName: "drops2",
  },
  {
    id: 28,
    title: "ERP",
    path: "/erp-software",
    cName: "drop_down_cont2",
    idName: "drops2",
  },

  {
    id: 11,
    title: " Biometric Based HRM",
    path: "/biometric-attendance",
    cName: "drop_down_cont1",
    idName: "drops1",
  },
  {
    id: 31,
    title: "School ERP",
    path: "/school-erp",
    cName: "drop_down_cont1",
    idName: "drops1",
  },
  {
    id: 17,
    title: "Gold Loan Management",
    path: "/gold-loan-software",
    cName: "drop_down_cont1",
    idName: "drops1",
  },
  {
    id: 32,
    title: "Matrimonial Website",
    path: "/matrimonial-website-development",
    cName: "drop_down_cont1",
    idName: "drops1",
  },
  {
    id: 18,
    title: "Medical Billing",
    path: "/medical-billing-software",
    cName: "drop_down_cont1",
    idName: "drops1",
  },
 
  {
    id: 14,
    title: "Mini Banking",
    path: "/mini-banking-software",
    cName: "drop_down_cont1",
    idName: "drops1",
  },

  {

    id:12,
    title: 'View All',
    path: '/all-products',
    cName: 'drop_down_cont1',
    idName:'drops1'
    },

  //   { id:16,
  //       title: 'POS On Billing',
  //       path: '/POSPage',
  //       cName: 'drop_down_cont1',
  //       idName:'drops1'
  //     },
];

export default ProductItems;
